module.exports = __webpack_public_path__ + "static/media/51_A.1469658a.png";